import { get, getOr, tap } from 'lodash/fp';
import * as designBuilderApi from '../api/designBuilder';
import estimateLoaded from './estimateLoaded';
import loaded from './loaded';
import loading from './loading';
import saveToMyAccount from './saveToMyAccount';
import globalError from './globalError';
import addEstimateToSelection from './share/addEstimateToSelection';
import initShareStore from './share/initShareStore';
import setWindowCategoryMappings from './availability/setWindowCategoryMappings';
import setMountTypes from './availability/setMountTypes';
import setSpecs from './availability/setSpecs';
import setOrigin from '../actions/setOrigin';
import PostMeasureOptionsCookie from '../models/postMeasureOptionsCookie';

export default designId => (dispatch, getState) => {
  dispatch(loading());

  return designBuilderApi
    .loadDesign(designId)
    .then((designApiResponse) => {
      const design = dispatch(estimateLoaded(designApiResponse));
      dispatch(initShareStore());
      dispatch(addEstimateToSelection(designId));

      const modeState = getOr('Unknown', 'attributes.origin')(design);
      dispatch(setOrigin(modeState));

      if (get('attributes.isMandi')(design)) {
        dispatch(setSpecs());
        dispatch(setWindowCategoryMappings());
        dispatch(setMountTypes());
        new PostMeasureOptionsCookie().delete();
      } else {
        const isLinked = getOr(false, `estimateBuilder.entities.estimates.byId[${designId}].isLinked`)(getState());
        if (!isLinked) {
          saveToMyAccount(designId)(dispatch, getState);
        }
      }

      return design;
    })
    .then(tap(() => dispatch(loaded())))
    .catch(err => dispatch(globalError({ err })));
};
